import { FC } from 'react'
import { IWaitingListRecord } from '../survey/SurveyModel/types/nodeTypes';
import dayjs from 'dayjs';

type OpDetailsProps = {
    waitingListRecord: IWaitingListRecord | null;
    isLoading: boolean;
}

const OpDetails: FC<OpDetailsProps> = ({ waitingListRecord }) => {
    return (
        <div className="op-details flex flex-row lg:gap-20 md:gap-4">
            <div className="op-details-item item-1 flex flex-col">
                <div className="title">OPCS-4/operation</div>
                <div className="details">{waitingListRecord?.operationProcedure || '--'}</div>
            </div>
            <div className="op-details-item item-2 flex flex-col">
                <div className="title">Priority</div>
                <div className="details">{waitingListRecord?.priority || '--'}</div>
            </div>
            <div className="op-details-item item-3 flex flex-col">
                <div className="title">Scheduled</div>
                <div className="details">{waitingListRecord?.operationDate ? dayjs(waitingListRecord.operationDate).format('DD/MM/YY') : '--'}</div>
            </div>

            <div className="op-details-item item-4 flex flex-col">
                <div className="title"> Appt. type</div>
                <div className="details">{waitingListRecord?.status || '--'}</div>
            </div>
            <div className="op-details-item item-4 flex flex-col">
                <div className="title"> POA appt. date</div>
                <div className="details">{waitingListRecord?.questionnaireResponsePOADateTime ? dayjs(waitingListRecord.questionnaireResponsePOADateTime).format('DD/MM/YY') : '--'}</div>
            </div>

            <div className="op-details-item item-4 flex flex-col">
                <div className="title"> Outcome</div>
                <div className="details">{waitingListRecord?.teamReviewOutcome?.replace(/"/g, '') || '--'}</div>
            </div>
            <div className="op-details-item item-4 flex flex-col">
                <div className="title"> Expiry</div>
                <div className="details">{waitingListRecord?.expirationDateTime ? dayjs(waitingListRecord.expirationDateTime).format('DD/MM/YY') : '--'}</div>
            </div>
            <div className="op-details-item item-4 flex flex-col">
                <div className="title">POA update</div>
                <div className="details">{waitingListRecord?.lastModifiedDateTime ? dayjs(waitingListRecord.lastModifiedDateTime).format('DD/MM/YY HH:mm') : '--'}</div>
            </div>
        </div>
    )
}

export default OpDetails
